import React, { useEffect } from "react";
import "../../styles/VoiceSupport.css";

export default function VoiceSupport({ onClose }) {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = "auto";
    };
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="voice-support-overlay" onClick={handleOverlayClick}>
      <div className="voice-support-modal">
        <button 
          className="voice-support-close-btn"
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>

        <div className="voice-support-content">
          <h1 className="voice-support-title">
            Checkout our advance voice based reporting
          </h1>

          <div className="voice-support-divider"></div>

          <div className="voice-support-logo">
            <span className="voice-support-logo-text">DICOM</span>
          </div>

          <div className="voice-support-divider"></div>

          <h2 className="voice-support-subtitle">
            DICOM now has voice based reporting
          </h2>

          <p className="voice-support-description">
            DICOM now offers voice-to-text integration for easy reporting - bottom heading 
            This feature is free for 1 month to all radiologists on DICOM, learn more by clicking here.
          </p>

          {/* Button Container */}
          <div className="voice-support-buttons">
            <button className="voice-support-btn voice-support-btn-primary">
              AUTO ENABLE MIC WHILE REPORTING
            </button>
            <button className="voice-support-btn voice-support-btn-secondary">
              MANUAL MIC
            </button>
          </div>

          <div className="voice-support-divider"></div>

          {/* Type Section */}
          <div className="voice-support-type">
            <span className="voice-support-type-label">Type:</span>
            <span className="voice-support-type-value">ALL</span>
          </div>

          {/* DICOM Logo Repeated Section */}
          <div className="voice-support-logos">
            <div className="voice-support-logos-row">
              <span className="voice-support-logo-item">DICOM</span>
              <span className="voice-support-logo-item">DICOM</span>
              <span className="voice-support-logo-item">DICOM</span>
              <span className="voice-support-logo-item">DICOM</span>
            </div>
            <div className="voice-support-logos-row">
              <span className="voice-support-logo-item">DICOM</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}